import vue from 'vue'
import { deleteMethods } from '@/components/tools/index.js'
const that = vue.prototype
export default {
  className: 'commodity',
  defaultOrder: 'weight',
  fields: [
    {
      name: 'productTitle',
      validators: [
        (val) => val ? null : '商品标题不可为空'
      ],
      tooltip: '商品标题过长在手机端会省略显示'
    },
    {
      name: 'category',
      validators: [
        (val) => val ? null : '商品分类不可为空'
      ]
    },
    {
      name: 'selfAndSelected',
      width: 150,
      note: '产品类别'
    },
    'selling',
    {
      name: 'offerContent',
      note: '说明'
    },
    {
      name: 'weight',
      validators: [
        (val) => val ? null : '排序不可为空'
      ]
    },
    {
      name: 'merchants',
      note: '商家',
      validators: [
        (val) => val ? null : '商家不可为空'
      ],
      targetClass: '_User',
      listWhere: (where) => {
        where.accountCategory = 'factoryAccount'
      }
    },
    {
      name: 'shelvesStatus',
      width: 150,
      validators: [
        (val) => val ? null : '上下架状态不可为空'
      ]
    },
    {
      name: 'showPictures',
      tooltip: '尺寸1 : 1，建议750px * 750px',
      validators: [
        (val) => val ? null : '展示图片不可为空',
        (val) => {
          if (val && !val.length) {
            return '展示图片不可为空'
          }
        }
      ]
    },
    {
      name: 'IntroductionEvent',
      validators: [
        (val) => val ? null : '商品介绍不可为空'
      ]
    },
    {
      name: 'inventory',
      tooltip: '该库存仅存于限时抢购，且为动态修改的库存，请谨慎修改',
      width: 150,
      validators: [
        (val) => {
          if (val % 1 !== 0) {
            return '库存必须为数字且为整数'
          }
        },
        (val) => val < 0 ? '库存必须为正整数' : null
      ]
    },
    {
      name: 'countyPrice',
      validators: [
        (val) => val ? null : '代理价格不可为空',
        (val) => val <= 0 ? '商品价格不正确' : null
      ],
      width: 150,
      tooltip: '必须整件定价',
      note: '代理价格'
    },
    {
      name: 'terminalPrice',
      validators: [
        (val) => val ? null : '终端价格不可为空'
      ],
      width: 150,
      tooltip: '必须单个定价',
      note: '终端价格'
    },
    {
      name: 'typeActivity',
      width: 150
    },
    {
      name: 'activityCountyPrice',
      width: 150,
      validators: [
        (val) => val && val <= 0 ? '活动价格不正确' : null
      ]
    },
    {
      name: 'activityTerminalPrice',
      width: 150,
      validators: [
        (val) => val && val <= 0 ? '活动价格不正确' : null
      ]
    },
    {
      name: 'snappingSales',
      width: 150,
      validators: [
        (val) => {
          if (val && val % 1 !== 0) {
            return '抢购销量必须为数字且为整数'
          }
        }
      ],
      tooltip: '抢购销量用于计算抢购进度，请设置正整数',
      note: '抢购销量'
    },
    {
      name: 'snappingInventory',
      width: 150,
      validators: [
        (val) => {
          if (val && val % 1 !== 0) {
            return '抢购库存必须为数字且为整数'
          }
        }
      ],
      tooltip: '用于计算抢购进度，请设置正整数',
      note: '抢购库存'
    }
  ],
  search: [
    'productTitle',
    'merchants',
    'shelvesStatus'
  ],
  action: {
    delete: {
      type: 'row',
      text: '删除',
      callback: deleteMethods
    }
  },
  hooks: {
    // 保存数据前判断
    async beforeSave (options) {
      let data = options.data
      // 如果商家存在判断该商家是否为厂家身份
      if (data.merchants) {
        let judgeUser = await that.$modelAjax.getList('user', { params: { where: { objectId: data.merchants } } })
        if (!judgeUser.length) {
          throw that.$notification['error']({
            message: '该商家不存在',
            description: '保存失败'
          })
        }
        if (judgeUser[0].accountCategory !== 'factoryAccount') {
          throw that.$notification['error']({
            message: '所选商家不为厂家',
            description: '保存失败'
          })
        }
      }
      // 选择活动后的验证
      if (data.typeActivity && (!data.activityCountyPrice || !data.activityTerminalPrice)) {
        throw that.$notification['error']({
          message: '活动价格不存在',
          description: '保存失败'
        })
      }
      if ((data.typeActivity && data.typeActivity === 'panicBuying') && (!data.inventory ||
        !data.snappingInventory)) {
        throw that.$notification['error']({
          message: '抢购信息不完整',
          description: '保存失败'
        })
      }
      // 活动价格与商品价格比较
      if ((data.activityCountyPrice && data.activityCountyPrice >= data.countyPrice) ||
        (data.activityTerminalPrice && data.activityTerminalPrice >= data.terminalPrice)) {
        throw that.$notification['error']({
          message: '活动价格不能高于商品价格',
          description: '保存失败'
        })
      }
    },
    // 增加数据前判断
    beforeInsert  ({ data }) {
      data.sales = 0
    }
  }
}
